import { type FC, type HTMLAttributes, type JSX } from 'react';

import styles from './SeriaPlusSection.css';

type SeriaPlusSectionProps = Omit<HTMLAttributes<HTMLElement>, 'id' | 'className'> & {
  id: string;
  children: JSX.Element;
};

export const SeriaPlusSection: FC<SeriaPlusSectionProps> = props => {
  const { id, children, ...restProps } = props;

  return (
    <section id={id} {...restProps} className={styles['section']}>
      {children}
    </section>
  );
};
